import { useEffect } from 'react';

// Risoluzione di riferimento: la UI di gioco è disegnata per 1920×1080.
// Sotto questa misura (es. 1280×720, 1366×768) scaliamo tutta la board in
// proporzione invece di lasciare che gli elementi si sovrappongano.
export const DESIGN_WIDTH = 1920;
export const DESIGN_HEIGHT = 1080;
const MIN_SCALE = 0.5;

export function computeUiScale(w: number, h: number): number {
  const s = Math.min(1, w / DESIGN_WIDTH, h / DESIGN_HEIGHT);
  return Math.max(MIN_SCALE, Math.round(s * 1000) / 1000);
}

// Aggiorna la variabile CSS globale --ui-scale (letta da .ui-scaled in
// Board.css) al mount e a ogni resize della finestra.
export function useUiScale(): void {
  useEffect(() => {
    const apply = () => {
      document.documentElement.style.setProperty(
        '--ui-scale',
        String(computeUiScale(window.innerWidth, window.innerHeight)),
      );
    };
    apply();
    window.addEventListener('resize', apply);
    return () => window.removeEventListener('resize', apply);
  }, []);
}
